import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "./useHttp";
import { toast } from "react-toastify";
import Version from "../Constant/version.json";
import { useDispatch } from "react-redux";
import { setHints } from "../Redux/Actions/TechAppAction";

export default function useApp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { HttpService } = useHttp();

  const [loading, setLoading] = useState(false);

  const sendBugReport = async (description, images) => {
    let platform = "";
    let data = new FormData();
    if (window.matchMedia("(display-mode: standalone)").matches) {
      platform = "pwa";
    } else {
      platform = "web";
    }
    data.append("description", description);
    data.append("app_type", "7");
    if (images.length > 0) {
      images.forEach((file) => {
        data.append("files[]", file);
      });
    }
    data.append("details[isPwa?]", platform);
    data.append("details[device_name]", navigator.userAgent);
    data.append("details[app_version]", Version.version);
    try {
      setLoading(true);
      const response = await HttpService.post("/api/app-reports", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (response.data.status === 200) {
        navigate(-1);
        toast.success(response?.data?.message);
      }
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  const getHints = async () => {
    try {
      const response = await HttpService.get("/api/v1.1/section_hints");
      dispatch(setHints(response.data));
    } catch ({ err, response }) {}
  };

  const exports = { sendBugReport, getHints, loading };

  return exports;
}
